export default __webpack_public_path__ + "images/train-tPr0t.gif";